/* tslint:disable */
/* eslint-disable */
export enum SecurityRuleSet {
  None = 'None',
  Level1 = 'Level1',
  Level2 = 'Level2'
}
